"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcornGridSuspense = void 0;
var react_1 = __importDefault(require("react"));
var SuspenseContentStatus_1 = require("../../types/SuspenseContentStatus");
var FetchingSuspense_1 = require("./FetchingSuspense");
var EmptyDataSuspenseContent = function (props) {
    if (props.isList) {
        return (react_1.default.createElement("div", { className: "c-alert +align-start", role: "alert" }, SuspenseContentStatus_1.SuspenseContentStatus.ListEmpty));
    }
    else {
        return react_1.default.createElement("p", null, SuspenseContentStatus_1.SuspenseContentStatus.ItemEmpty);
    }
};
var FetchingDataSlowlySuspenseContent = function (props) {
    // For lists, we always want to show the content if we have some otherwise the
    // page 'breathes' up and down as the table empties and reloads.
    if (props.itemFetchingStatus.fetched) {
        return react_1.default.createElement(react_1.default.Fragment, null,
            props.children,
            " ");
    }
    return react_1.default.createElement(FetchingDataSuspenseContent, __assign({}, props));
};
var FetchingDataSuspenseContent = function (props) {
    return react_1.default.createElement("p", null, SuspenseContentStatus_1.SuspenseContentStatus.ListLoading);
};
var AcornGridSuspense = function (props) {
    return (react_1.default.createElement(FetchingSuspense_1.FetchingSuspense, __assign({ emptyComponent: EmptyDataSuspenseContent, fetchingSlowlyComponent: FetchingDataSlowlySuspenseContent }, props)));
};
exports.AcornGridSuspense = AcornGridSuspense;
//# sourceMappingURL=AcornGridSuspense.js.map